(function () {
  if (window.__nlSatc) return;
  window.__nlSatc = true;

  function init() {
    var dataEl = document.getElementById('nl-satc-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function scope() { return document.querySelector('product-info[id^="MainProduct-"]') || document; }
    function mainForm() { return scope().querySelector('form[data-type="add-to-cart-form"]'); }
    function mainBtn() { var f = mainForm(); return f && f.querySelector('[name="add"]'); }
    if (!mainBtn()) return;

    var bar = document.createElement('div');
    bar.className = 'nl-satc';
    bar.id = 'nl-satc';
    bar.setAttribute('aria-hidden', 'true');
    bar.setAttribute('inert', '');
    bar.innerHTML =
      '<div class="nl-satc__in">' +
        '<img class="nl-satc__img" alt="" width="48" height="48" hidden>' +
        '<div class="nl-satc__info">' +
          '<div class="nl-satc__title"></div>' +
          '<div class="nl-satc__meta"><span class="nl-satc__variant"></span>' +
          '<span class="nl-satc__price"><s class="nl-satc__was"></s><strong class="nl-satc__now"></strong></span></div>' +
        '</div>' +
        '<button type="button" class="nl-satc__btn">' +
          '<svg class="nl-satc__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"></circle><circle cx="18" cy="20" r="1.4"></circle><path d="M2.5 3.5h2.6l2.4 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2l1.7-7.3H6.1"></path></svg>' +
          '<span class="nl-satc__label">Add to cart</span></button>' +
      '</div>';
    document.body.appendChild(bar);

    var img = bar.querySelector('.nl-satc__img');
    var btn = bar.querySelector('.nl-satc__btn');
    bar.querySelector('.nl-satc__title').textContent = data.title;

    function currentVariant() {
      var f = mainForm();
      var input = f && f.querySelector('input[name="id"]');
      var id = input && Number(input.value);
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === id) return data.variants[i];
      return data.variants[0];
    }

    function sync() {
      var v = currentVariant();
      var main = mainBtn();
      bar.querySelector('.nl-satc__variant').textContent = data.single ? '' : (v ? v.title : '');
      bar.querySelector('.nl-satc__now').textContent = v ? v.price : '';
      var was = bar.querySelector('.nl-satc__was');
      was.textContent = v && v.compare ? v.compare : '';
      was.hidden = !(v && v.compare);
      var src = (v && v.img) || data.img;
      if (src) { img.src = src; img.hidden = false; } else { img.hidden = true; }
      var disabled = !main || main.disabled || main.hasAttribute('disabled');
      btn.disabled = disabled;
      var mainLabel = main && main.querySelector('span');
      bar.querySelector('.nl-satc__label').textContent = disabled && mainLabel ? mainLabel.textContent.trim() : 'Add to cart';
    }

    var visible = false;
    function setVisible(show) {
      if (show === visible) return;
      visible = show;
      if (show) sync();
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('nl-satc-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    // Show only after the customer has scrolled past the main button (button fully above the screen)
    var ticking = false;
    function check() {
      ticking = false;
      var b = mainBtn();
      if (!b || !b.offsetParent) { setVisible(false); return; }
      setVisible(b.getBoundingClientRect().bottom < 0);
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    function watch() { queue(); }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check();

    btn.addEventListener('click', function () {
      var b = mainBtn();
      if (!b || b.disabled) return;
      b.click();
    });

    function onChange() { setTimeout(function () { watch(); sync(); }, 60); }
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, onChange);
        if (PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, onChange);
      }
    } catch (e) {}
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-selects')) onChange();
    });
    new MutationObserver(function () { sync(); watch(); }).observe(scope(), { attributes: true, subtree: true, attributeFilter: ['disabled'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
